var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7,8.4c0-0.7-0.3-1.3-0.7-1.8c-0.5-0.5-1.1-0.7-1.8-0.7h-3.1l-0.3-1.3h0c-0.1-0.5-0.5-1-0.9-1.4c-0.4-0.3-1-0.5-1.6-0.5 H9.5c-0.6,0-1.1,0.2-1.6,0.5C7.5,3.6,7.1,4.1,7,4.6L6.7,5.9H3.6C3,5.9,2.3,6.2,1.8,6.6C1.4,7.1,1.1,7.8,1.1,8.4v10 c0,0.7,0.3,1.3,0.7,1.8C2.3,20.7,3,21,3.6,21h16.6c0.7,0,1.3-0.3,1.8-0.7c0.5-0.5,0.7-1.1,0.7-1.8L22.7,8.4z M21.7,18.4 c0,0.4-0.2,0.8-0.4,1.1c-0.3,0.3-0.7,0.4-1.1,0.4H3.6c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.7-0.4-1.1v-10c0-0.4,0.2-0.8,0.4-1.1 c0.3-0.3,0.7-0.4,1.1-0.4h3.5c0.2,0,0.4-0.2,0.5-0.4L8,4.9C8.1,4.5,8.3,4.2,8.5,4c0.3-0.2,0.6-0.3,0.9-0.3h4.9 c0.3,0,0.7,0.1,0.9,0.3c0.3,0.2,0.5,0.5,0.5,0.8l0.4,1.7c0.1,0.2,0.3,0.4,0.5,0.4h3.5c0.4,0,0.8,0.2,1.1,0.4 c0.3,0.3,0.4,0.7,0.4,1.1L21.7,18.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6.5c-1.4,0-2.8,0.6-3.7,1.6c-1,1-1.6,2.3-1.6,3.7c0,1.4,0.6,2.8,1.6,3.7c1,1,2.3,1.6,3.7,1.6s2.8-0.6,3.7-1.6 c1-1,1.6-2.3,1.6-3.7c0-1.4-0.6-2.7-1.6-3.7C14.8,7.1,13.4,6.5,12,6.5L12,6.5z M12,16.1c-1.1,0-2.2-0.5-3-1.3 c-0.8-0.8-1.3-1.9-1.3-3c0-1.1,0.5-2.2,1.3-3c0.8-0.8,1.9-1.3,3-1.3s2.2,0.5,3,1.3c0.8,0.8,1.3,1.9,1.3,3c0,1.1-0.5,2.2-1.3,3 C14.3,15.6,13.2,16.1,12,16.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.728ae7b78cf4c7a3a8678b08f2e75136.svg";
export { ForwardRef as ReactComponent };